var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "avatar-uploader",
      attrs: {
        action: _vm.action,
        headers: _vm.headers,
        disabled: _vm.disabled,
        "show-file-list": false,
        "on-error": _vm.handleError,
        "on-success": _vm.handleSuccess,
        "on-progress": _vm.onProgress,
        accept: _vm.accept,
        data: _vm.params,
        "before-upload": _vm.beforeAvatarUpload,
      },
    },
    [
      _vm._imageUrl
        ? _c("img", {
            ref: "img",
            staticClass: "avatar",
            attrs: { src: _vm._imageUrl },
            on: { load: _vm.onLoad },
          })
        : _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "trigger" },
              slot: "trigger",
            },
            [_vm._v(_vm._s(_vm.$t("certification.add.pic")))]
          ),
      _vm.reuplaodBtn
        ? _c("span", { staticClass: "reupload-text" }, [
            _vm._v(_vm._s(_vm.$t("certification.add.reupload"))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }